<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách tổng hợp phiếu KPI</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search">
          <div class="form-group">
            <Select2 v-model="search.regionId" :options="optionRegion" placeholder="Vùng">
            </Select2>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Tháng KPI"
              v-model="search.monthlyKpi"
            />
          </div>
          <div class="form-group">
            <Select2
              placeholder="Quản lý"
              v-model="search.superiorId"
              :options="optionSup"
              @change="changeGetStaff"
            >
            </Select2>
          </div>
          <div class="form-group">
            <select2-multiple-control
              :settings="{ placeholder: 'CVKD' }"
              v-model="search.saleIds"
              :options="optionSaleIds"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2 placeholder="Trạng thái" v-model="search.status" :options="optionStatus">
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              class="btn btn-primary hc-37 mr-2 pt-2"
              @click.prevent="submitSearchForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              @click.prevent="clearSearch"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              class="mt-1"
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataLists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #head(index)>
                <div class="text-center">STT</div>
              </template>
              <template #head(status)>
                <div class="text-center">Trạng thái</div>
              </template>
              <template #head(action)>
                <div class="text-center">Thao tác</div>
              </template>
              <template #cell(index)="data">
                <div class="text-center">{{ getIndex(data.index) }}</div>
              </template>
              <template #cell(sale)="data">
                <p>Tên: {{ data.item.sale.name }}</p>
                <p>Email: {{ data.item.sale.email }}</p>
                <p>QLTT: {{ data.item.sale.superiorName }}</p>
              </template>
              <template #cell(monthlyKpi)="data">
                <div>{{ data.item.monthlyKpi }}</div>
              </template>
              <template #cell(regionName)="data">
                <div class="white-space">
                  {{ data.item.sale.regionName }}
                </div>
              </template>
              <template #cell(numberKpiRequest)="data">
                <div class="text-right">
                  {{ data.item.numberKpiRequest | formatNum }}
                </div>
              </template>
              <template #cell(totalKpi)="data">
                <div class="text-right">
                  {{ data.item.totalKpi | formatNum }}
                </div>
              </template>
              <template #cell(numberKpiFinal)="data">
                <div class="text-right">
                  {{ data.item.numberKpiFinal | formatNum }}
                </div>
              </template>
              <template #cell(status)="data">
                <div class="text-center">
                  {{ data.item.status | statusKPIOrders }}
                </div>
              </template>
              <template #cell(action)="data">
                <div class="text-center">
                  <b-dropdown variant="outline-light">
                    <b-dropdown-item @click="clickViewDetail(data.item)" class="dropdown-item"
                      >Chi tiết KPI
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="openConfrimKPi(data.item)"
                      class="dropdown-item"
                      v-if="data.item.status == 'NOT_CONFIRM' || data.item.status == null"
                      >Chốt KPI
                    </b-dropdown-item>
                    <b-dropdown-item @click="kpiCalculateOrder(data.item)" class="dropdown-item"
                      >Tính lại
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            class="mr-2 fl-right"
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
          >
          </b-pagination>
        </div>
        <VueLoadingOverlay :active.sync="loading" :is-full-page="true"></VueLoadingOverlay>
        <b-modal id="modal-scoped" v-model="confirmModal">
          <template #modal-header="{ close }">
            <h5>Chốt KPI ghi nhận</h5>
            <b-button size="sm" variant="light" @click="close()"> x </b-button>
          </template>
          <div v-if="itemConfirm.sale">
            <div>
              <label class="label-confrm">Chuyên viên kinh doanh:</label>
              {{ itemConfirm.sale.name }}
            </div>
            <div>
              <label class="label-confrm">Quản lý trực tiếp:</label>
              {{ itemConfirm.sale.superiorName }}
            </div>
            <div>
              <label class="label-confrm">Vùng:</label>
              {{ itemConfirm.regionName }}
            </div>
            <div>
              <label class="label-confrm">Tổng số KPI:</label>
              {{ itemConfirm.totalKpi | formatNum }}
            </div>
          </div>
          <template #modal-footer="{ cancel }">
            <b-button variant="light" @click="cancel()"> Bỏ qua </b-button>
            <b-button variant="primary" @click="confirmKpi()"> Lưu </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { KpiSaleOrderService } from '@/services/kpi.sale.order.service'
  import cloneDeep from 'lodash/cloneDeep'
  // import { MonthPickerInput } from 'vue-month-picker'

  const fieldsTable = [
    { key: 'index', label: 'STT' },
    { key: 'sale', label: 'CVKD' },
    { key: 'monthlyKpi', label: 'Tháng tính KPI' },
    { key: 'regionName', label: 'Vùng' },
    { key: 'numberKpiRequest', label: 'KPI yêu cầu' },
    { key: 'totalKpi', label: 'KPI tạm tính' },
    { key: 'numberKpiFinal', label: 'KPI hoàn thành' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác' },
  ]

  export default {
    components: {
      // MonthPickerInput
    },
    data() {
      return {
        loading: false,
        userData: JSON.parse(localStorage.getItem('userData')),
        fieldsTable,
        filterTable: fieldsTable,
        dataLists: [],
        search: {
          regionId: '',
          monthlyKpi: '',
          superiorId: '',
          saleIds: [],
          limit: 10,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        optionRegion: [],
        optionSup: [],
        dataSup: [],
        optionStatus: [
          { id: '0', text: 'Tất cả' },
          { id: 'CONFIRMED', text: 'Đã chốt' },
          { id: 'NOT_CONFIRM', text: 'Chưa chốt' },
        ],
        optionSaleIds: [],
        confirmModal: false,
        itemConfirm: {},
        // objMonthlyKpi: {},
        // months: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12']
      }
    },
    created() {
      this.getRegions()
      this.getSup()
      this.fetchData()
    },

    watch: {
      'search.page': function () {
        this.fetchData()
      },
      'search.limit': function () {
        this.fetchData()
      },
    },

    methods: {
      async submitSearchForm() {
        this.search.page = 1
        this.fetchData()
      },
      clearSearch() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.fetchData()
      },
      async fetchData() {
        try {
          this.loading = true
          const search = cloneDeep(this.search)
          const data = await KpiSaleOrderService.kpiGetList(search)
          if (data.success) {
            this.pagination.total = data.data.count ? data.data.count : 0
            this.dataLists = data.data.list
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async getRegions() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionRegion.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },
      async getSup() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userData.userId,
          })
          if (data.success) {
            this.optionSup = data.data.map(e => {
              this.dataSup.push({ id: e.userId, mail: e.userName })
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.optionSup.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async changeGetStaff() {
        try {
          this.loading = true
          if (this.search.superiorId != '' && this.search.superiorId != '0') {
            const search = {
              userId: this.search.superiorId,
            }
            const data = await StaffService.getListSubordinateV3(search)
            if (data.success) {
              this.optionSaleIds = data.data.map(e => {
                return {
                  id: e.id,
                  text: `${e.name} - ${e.email}`,
                }
              })
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      openConfrimKPi(item) {
        this.confirmModal = true
        this.itemConfirm = item
        console.log(item)
      },
      async confirmKpi() {
        try {
          this.loading = true
          const item_id = this.itemConfirm?.id
          if (item_id !== '') {
            const params = { id: item_id }
            const data = await KpiSaleOrderService.kpiConfirm(params)
            if (data.success) {
              this.fetchData()
              this.showSuccessMx(data.message)
            }
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.loading = false
          this.confirmModal = false
        }
      },
      clickViewDetail(item) {
        // this.$router.push({ path: `/kpi-sale/kpi-order-item-detail/${item.id}` });
        window.open(`/kpi-sale/kpi-order-item-detail/${item.id}`, '_blank')
      },
      async kpiCalculateOrder(item) {
        try {
          this.loading = true
          const item_id = item.id
          if (item_id !== '') {
            const params = { id: item_id }
            const data = await KpiSaleOrderService.kpiCalculateOrder(params)
            if (data.success) {
              this.fetchData()
              this.showSuccessMx(data.message)
            }
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
<style scoped>
  .white-space {
    width: 250px;
    white-space: wrap;
  }
  .label-confrm {
    font-weight: 700;
    width: 40%;
    display: inline-block;
  }
  .text-red {
    color: red;
  }
  ::v-deep .month-picker__container * {
    font-size: 14px !important;
  }
  ::v-deep .month-picker-input,
  ::v-deep .month-picker-input-container {
    width: 100% !important;
    font-size: 13px !important;
    color: #495057 !important;
  }
  ::v-deep .month-picker__container {
    z-index: 999999;
    width: 210px !important;
  }
  ::v-deep .month-picker__year button:first-child,
  ::v-deep .month-picker__year button:last-child {
    width: 25px !important;
    height: 28px !important;
  }
  ::v-deep .month-picker__year p {
    margin: 8px 0 !important;
  }
  ::v-deep .month-picker__month {
    border: 1px solid #ddd !important;
    border-radius: 0 !important;
    padding: 8px 2px !important;
    text-shadow: none;
  }
</style>
